<div class="company-dids-filters">
  <div class="company-dids-filters__quick-filters" *ngIf="quickFilters">
    <span>{{ 'company.dids.dids-filters.quick-filters.title' | translate}}:</span>
    <ul>
      <li *ngFor="let filter of quickFilters; let isLast=last" (click)="parseExternalFilters(filter.filters)">
        <span translate>{{filter.name}}</span>{{isLast ? '' : ',&ensp;'}}
      </li>
    </ul>
  </div>
  <div class="company-dids-filters__filters" *ngIf="form">
    <form [formGroup]="form" class="company-dids-filters__form">
      <div class="company-dids-filters__filter" [ngClass]="{'company-dids-filters__filter-end': usedFilters.length > 1}"
        *ngFor="let used of usedFilters; let uIdx = index">
        <div class="company-dids-filters__filter-selector">
          <button class="company-dids-filters__filter-remove  vox-btn vox-btn-secondary-grey" type="button"
            (click)="removeFilter(uIdx)" [ngClass]="{'hidden': usedFilters.length === 1}"
            [disabled]="used.isLocked || used.name==='country_code' && form.get('area_code')">
            <i class="company-dids-filters__filter-remove_symbol icon-small-remove"></i>
          </button>
          <div ngbDropdown class="vox-dropdown-input">
            <button class="company-dids-filters__filter-dropdown_btn" id="company-dids-filters-dropdown-{{uIdx}}"
              ngbDropdownToggle [disabled]="isFilterSelectorEnabled(used)">
              {{ 'company.dids.dids-filters.filters.' + used.name | translate}}
            </button>
            <div class="company-dids-filters__filter-dropdown_menu" ngbDropdownMenu
              aria-labelledby="company-dids-filters-dropdown">
              <button ngbDropdownItem class="company-dids-filters__filter-dropdown_item" type="button"
                *ngFor="let filter of availableFilters; let idx = index" (click)="swapFilters(uIdx, idx)">
                {{'company.dids.dids-filters.filters.' + filter.name | translate}}
              </button>
            </div>
          </div>
        </div>
        <div class="company-dids-filters__filter-input-container" [ngSwitch]="used.type">
          <div class="company-dids-filters__filter-input vox-input-group vox-input-group_dense">
            <input *ngSwitchCase="'input'"
              [readonly]="used.isLocked"
              [formControlName]="used.name"
              (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();"
              class="vox-text-field"
              type="text">
          </div>
          <div class="company-dids-filters__filter-input vox-input-group vox-input-group_dense">
            <vox-select-prefix *ngSwitchCase="'prefix'"
              [language]="currentLanguage"
              [formControlName]="used.name"
              [dense]="true"
              [country]="form.get('country_code').value">
            </vox-select-prefix>
          </div>
          <div class="company-dids-filters__filter-input vox-input-group vox-input-group_dense">
            <gdp-date-picker  *ngSwitchCase="'datepicker'"
              [formControlName]="used.name"
              [maxDate]="calendar.getToday()"
              [minDate]="used.name==='creation_date_to' && form.get('creation_date_from')?.value">
            </gdp-date-picker>
          </div>
          <div class="company-dids-filters__filter-input vox-input-group vox-input-group_dense">
            <vox-select-country *ngSwitchCase="'country_selector'"
              [language]="currentLanguage"
              [formControl]="form.get(used.name)"
              [dense]="true">
            </vox-select-country>
          </div>
          <div *ngSwitchCase="'dropdown'" ngbDropdown class="vox-dropdown-input">
            <button id="company-dids-filters-dropdown-{{used.name}}" ngbDropdownToggle>
              <span *ngIf="used.name === 'status'">{{form.get(used.name).value | didStatus}}</span>
              <span *ngIf="used.name !== 'status'">{{form.get(used.name).value}}</span>
            </button>
            <div ngbDropdownMenu class="company-dids-filters-dropdown" aria-labelledby="company-dids-filters-dropdown">
              <button ngbDropdownItem type="button" *ngFor="let d of used.data"
                (click)="form.get(used.name).setValue(d)">
                <span *ngIf="used.name !== 'status'">{{d}}</span>
                <span *ngIf="used.name === 'status'">{{d | didStatus}}</span>
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'dropdown-provider'" ngbDropdown class="vox-dropdown-input">
            <gdp-select-provider formControlName="provider" [providers]="used.data"></gdp-select-provider>
          </div>
          <div *ngSwitchCase="'class'" ngbDropdown class="vox-dropdown-input">
            <button id="company-dids-filters-dropdown-{{used.name}}" ngbDropdownToggle>
              {{ form.get(used.name).value | didClass }}
            </button>
            <div ngbDropdownMenu aria-labelledby="company-dids-filters-dropdown">
              <button ngbDropdownItem type="button" *ngFor="let d of used.data"
                (click)="form.get(used.name).setValue(d)">
                {{d | didClass }}
              </button>
            </div>
          </div>
          <div *ngSwitchCase="'type'" ngbDropdown class="vox-dropdown-input">
            <button id="company-dids-filters-dropdown-{{used.name}}" ngbDropdownToggle>
              {{ form.get(used.name).value | didType }}
            </button>
            <div ngbDropdownMenu aria-labelledby="company-dids-filters-dropdown">
              <button ngbDropdownItem type="button" *ngFor="let d of used.data"
                (click)="form.get(used.name).setValue(d)">
                {{d | didType | uppercase }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="company-dids-filters__filter-add_container">
        <button class="vox-btn vox-btn-secondary company-dids-filters__filter-add" type="button" (click)="addFilter(0)"
          [disabled]="availableFilters.length < 1">
          <i class="company-dids-filters__filter-add_symbol icon-small-add">
          </i>
        </button>
        <button class="vox-btn vox-btn-secondary company-dids-filters__filter-apply" type="submit"
          [disabled]="!canFilter"
          (click)="emitFilters()">
          {{'company.dids.dids-filters.actions.apply-filters' | translate}}
        </button>
        <button class="ml-2 btn btn-link company-dids-filters__filter-clear" type="button" (click)="resetFilters()">
          {{'company.dids.dids-filters.actions.clear-filters' | translate}}
        </button>
      </div>
    </form>
  </div>
</div>
